if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      validateBundle() {
        return Array.from(
          document.querySelectorAll(".bundle-product-selector select.required"),
        )
          .map((item) => {
            if (!item.value || !item.value.length) {
              item.parentNode.classList.add("error");
              return false;
            }
            return true;
          })
          .every((item) => item);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.validateBundle()) {
          return;
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");

        const formData = new FormData(this.form);
        const upsell = Array.from(
          document.querySelectorAll(".bundle-product-selector select"),
        )
          .filter((item) => item.value)
          .map((item) => ({
            id: item.value,
            quantity: item.dataset.amount | 1,
          }));
        console.log(upsell);
        if (upsell && upsell.length) {
          const bodyItems = [
            {
              id: formData.get("id"),
              quantity: formData.get("quantity"),
              properties: {
                _main_product_bundle: true,
              },
            },
          ];

          upsell.forEach(({ id, quantity }) => {
            bodyItems.push({
              id,
              quantity: quantity,
              properties: {
                _product_bundle: true,
              },
            });
          });

          config.body = JSON.stringify({
            items: bodyItems,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
          });
        } else {
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          config.body = formData;
        }
        this.cart.setActiveElement(document.activeElement);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart.productAddedToCart) this.cart.productAddedToCart();
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!customElements.get("bundle-product-selector")) {
  customElements.define(
    "bundle-product-selector",
    class BundleProductSelector extends HTMLElement {
      constructor() {
        super();
        this.selector = this.querySelector("#cableSelect");
        this.selector.addEventListener(
          "change",
          this.onChangeHandler.bind(this),
        );
      }

      onChangeHandler(e) {
        const option = e.target.options[e.target.selectedIndex];
        if (option.dataset.type == "wieland") {
          this.classList.add("showCase");
          this.classList.remove("showEnergyMeter");
          this.querySelector(".bundle-product--energy_meter select").value = "";
        } else if (option.dataset.type == "schuko") {
          this.classList.add("showEnergyMeter");
          this.classList.remove("showCase");
          this.querySelector(".bundle-product--case select").value = "";
        }
        console.log(option.dataset.type);
        //document.querySelector("[name='_cable_id']").value = e.target.value;
      }
    },
  );
}

customElements.define(
  "product-selection-set",
  class ProductSelectionSet extends HTMLElement {
    constructor() {
      super();
      console.log("dad");
      this.selectionList = document.querySelectorAll(
        ".bundle-product--general select",
      );
      this.selectionList.forEach((item, index) => {
        item.addEventListener("change", (e) => this.onChangeHandler(e, index));
      });
    }

    onChangeHandler(e, index) {
      const handle = e.target.selectedOptions[0].dataset.handle;
      if (handle) {
        fetch(`/products/${handle}?view=lieferumfang`)
          .then((response) => response.text())
          .then((response) => {
            var wrapperElement = this.querySelector(
              `div[data-index="${index}"]`,
            );
            if (!wrapperElement) {
              wrapperElement = document.createElement("div");
              wrapperElement.dataset.index = index;
              this.appendChild(wrapperElement);
            }
            wrapperElement.innerHTML = response;
          });
      } else {
        var wrapperElement = this.querySelector(`div[data-index="${index}"]`);
        if (wrapperElement) {
          wrapperElement.innerHTML = "";
        }
      }
    }
  },
);
